import Behavior from "./components/Behavior";
import * as DefaultBehaviors from "./components/DefaultBehaviors";
import type { TEIComponentMap, TEIComponentProps } from "./components/TEINode";
import BasicRouter from "./components/BasicRouter";
import { TEINode, TEINodes } from "./components/TEINode";

export { BasicRouter as default, BasicRouter, Behavior, DefaultBehaviors, TEINode, TEINodes };
export type { TEIComponentMap, TEIComponentProps }